import { VolumeUp } from '@carbon/icons-react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FormControl, MenuItem, Select } from '@mui/material';

import { useMediaDevicesContext } from '../../providers/media-devices-context';

export const SpeakerSelector = () => {
  const {
    speakers,
    selectedSpeaker,
    setSelectedSpeaker,
    isRequestingPermissions,
  } = useMediaDevicesContext();

  return (
    <FormControl fullWidth>
      <Select
        value={selectedSpeaker || ''}
        onChange={(e) => setSelectedSpeaker(e.target.value)}
        disabled={isRequestingPermissions}
        startAdornment={<VolumeUp size={26} />}
        IconComponent={KeyboardArrowDownIcon}
        variant='filled'
        sx={{
          borderRadius: 1,
          '.MuiSelect-select': {
            fontSize: '0.875rem',
          },
          '& fieldset': {
            border: 'none',
          },
        }}
      >
        {speakers.map((speaker) => (
          <MenuItem
            key={speaker.deviceId}
            value={speaker.deviceId}
            sx={{ fontSize: '0.875rem' }}
          >
            {speaker.label || `Speaker ${speaker.deviceId.substr(0, 5)}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
